import { AxiosInstance } from 'axios';

export type UserType = 'Superadmin' | 'OrgUser' | 'User';

export interface UserResponse {
  id: number;
  sub?: string | null;
  second_name?: string;
  organization?: string;
  department?: string;
  appointment?: string;
  snils?: string;
  password: string;
  last_login?: string;
  is_superuser: boolean;
  username: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  is_staff: boolean;
  is_active: boolean;
  date_joined?: string;
  groups?: Set<number>;
  user_type: UserType;
}

export interface User {
  id: number;
  secondName?: string;
  username: string;
  firstName?: string;
  lastName?: string;
  isSuperUser: boolean;
  userType: UserType;
}

export class APIUser {
  constructor(private _axios: AxiosInstance) {}

  protected _uri = '/api/user-profile-open';
  protected _serialize = (data: UserResponse): User => ({
    id: data.id,
    username: data.username,
    secondName: data.second_name,
    firstName: data.first_name,
    lastName: data.last_name,
    isSuperUser: data.is_superuser,
    userType: data.user_type,
  });

  async getProfile(params: URLSearchParams = new URLSearchParams()) {
    const response = await this._axios.get<UserResponse>(`${this._uri}/`, {
      params,
    });

    // @ts-ignore
    return this._serialize(response.data);
  }
}
